import { Link, Flex, Text, CloseButton } from '@chakra-ui/react';
import type { PackageError } from '@halo/chat-sdk';
import { useTranslation } from 'react-i18next';
import IconError from './images/error.svg?react';

export interface NetworkErrorContentProps {
  packageError: PackageError;
  onRetry: () => void;
}

export function NetworkErrorContent({ packageError, onRetry }: NetworkErrorContentProps) {
  const { t } = useTranslation();
  return (
    <Flex align="center" justify="center" py={3} fontSize="sm" bg="bg.error" mb="2" gap="2">
      <IconError />
      <Text as="span">
        {t('errors.networkErrorType', { errorType: packageError.error_type })}
      </Text>
      <Link color="fg.error" as="span" onClick={onRetry} textDecoration="underline">
        {t('action.pleaseRetry')}
      </Link>
    </Flex>
  );
}

export interface SessionErrorContentProps {
  packageError: PackageError;
}

export function SessionErrorContent({ packageError }: SessionErrorContentProps) {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <Flex
      align="center"
      justify="center"
      py={3}
      fontSize="sm"
      bg="bg.error"
      mb="2"
      gap="2"
      pos="relative"
    >
      <IconError />
      <Text as="span">
        {t('errors.networkErrorCheck', { errorType: packageError.error_type })}
      </Text>
      <CloseButton
        size="sm"
        color="inherit"
        onClick={() => setIsOpen(false)}
        pos="absolute"
        right="2"
        top="1"
      ></CloseButton>
    </Flex>
  );
}
